import { Component, Vue } from 'vue-property-decorator';
import { hasToken } from '@/services';
import { UserDTO } from '@/models';
import Notification from '@/components/common/notification/Notification.vue';
import OnBoarding from '@/components/common/on-boarding/OnBoarding.vue';
import PageHeader from '@/components/common/page-header/PageHeader.vue';
import PageLoader from '@/components/common/loader/page-loader/PageLoader.vue';
import Sidebar from '@/components/common/sidebar/Sidebar.vue';
import FeedbackBox from '@/components/common/feedback-box/FeedbackBox.vue'

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);

@Component({
  components: {
    Notification,
    OnBoarding,
    PageHeader,
    PageLoader,
    Sidebar,
    FeedbackBox
  }
})
export default class App extends Vue {
  get currentUser(): UserDTO {
    return this.$store.getters['app/currentUser'];
  }
  
  get isCurrentUserFetching(): boolean {
    return this.$store.getters['app/isCurrentUserFetching'];
  }

  async created(): Promise<void> {
    if (hasToken()) {
      await this.$store.dispatch('app/fetchCurrentUser');
    }
  }
}
